import $ from '../lib/jquery';

export function initHeader() {
	if (typeof jQuery === 'undefined') {
		console.warn('Header: jQuery is not available');
		return;
	}

	const headerWrapper = document.querySelector('.header_wrapper');
	const menu = document.querySelector('.headermenu');

	// Exit if no header elements found
	if (!headerWrapper) {
		return;
	}

	$(function () {
		/* Scroll header */
		$(window).on('scroll', function () {
			if ($(document).scrollTop() > 100) {
				$(headerWrapper).addClass('scrolled');
			} else {
				$(headerWrapper).removeClass('scrolled');
			}
		});

		/* Detect scroll direction */
		let lastScrollTop = 0;
		$(window).on('scroll', function () {
			const st = $(this).scrollTop();
			if (st > lastScrollTop && st !== 0) {
				$(headerWrapper).addClass('down');
			} else {
				$(headerWrapper).removeClass('down');
			}
			lastScrollTop = st;
		});

		/* Language Switcher */
		$('.language.is-active').on('click', function () {
			return false;
		});

		/* Open/Close Menu */
		const menuButton = $('.menu_button');
		if (menuButton.length && menu) {
			menuButton.on('click', function () {
				const isActive = $(this).hasClass('is-active');

				if (isActive) {
					// Close menu
					$('body').css('overflow-y', 'scroll');
					$(this).removeClass('is-active');
					$('.header_menu_controls .menu_button').removeClass('is-active');
					$('.header_menu_controls .menu_button').addClass('is-active');
					$(headerWrapper).removeClass('openmenu');

					closeMenu();
				} else {
					// Open menu
					$(this).addClass('is-active');
					$('.header_menu_controls .menu_button').addClass('is-active');
					$('body').css('overflow-y', 'hidden');
					$('.headermenu').addClass('is-active');
					$(headerWrapper).addClass('openmenu');

					openMenu();
				}
			});
		}

		/* Menu AOS animation */
		const isDesktop = window.innerWidth > 768;
		const menuSelector = isDesktop ? 'header .main-menu > div > ul' : 'header .main-menu';

		// $(menuSelector).each(function (menuIndex) {
		// 	$(this)
		// 		.find('> li, li')
		// 		.each(function (index) {
		// 			$(this)
		// 				// .attr('data-aos', 'fade-up')
		// 				// .attr('data-aos-duration', '900')
		// 				// .attr('data-aos-easing', 'menu-easing')
		// 				// .addClass('aos-init');

		// 			const delay = isDesktop ? 100 + index * 100 + menuIndex * 300 : 100 + index * 100;
		// 			$(this).attr('data-aos-delay', delay);

		// 			setTimeout(() => {
		// 				$(this).removeClass('aos-animate');
		// 			}, 300);
		// 		});
		// });
	});

	function openMenu() {
		if (!menu) return;
		menu.classList.remove('is-exiting');
		menu.classList.add('is-active');
	}

	function closeMenu() {
		if (!menu) return;
		menu.classList.remove('is-active');
		menu.classList.add('is-exiting');

		setTimeout(() => {
			menu.classList.remove('is-exiting');
			menu.style.transition = 'none';
			void menu.offsetHeight;
			menu.style.transition = '';
		}, 1000);
	}

	/* Language toggle */
	const languages = document.querySelector('.nav-menu-languages');
	const language = document.querySelector('.language.is-active');
	if (language && languages) {
		language.addEventListener('click', () => {
			languages.classList.toggle('active');
		});
	}

	/* Submenu hover for desktop */
	if (window.innerWidth > 768) {
		document.querySelectorAll('.menu-item-has-children').forEach((parent) => {
			const submenu = parent.querySelector('.sub-menu');
			if (submenu) {
				parent.addEventListener('mouseenter', () => submenu.classList.add('hovered'));
				parent.addEventListener('mouseleave', () => submenu.classList.remove('hovered'));
			}
		});
	}
}
